import { Box, IconButton, Stack, Sheet, Typography } from "@mui/joy";
import { Outlet, useLocation } from "react-router";
import HeaderLK from "../../components/HeaderLK/HeaderLK";
import Sidebar from "../../components/Sidebar/Sidebar";

import { motion } from "framer-motion";
import SidebarDraftsman from "../../components/Sidebar/SidebarDraftsman";
import SidebarSurveyor from "../../components/Sidebar/SidebarSurveyor";

import { useContext, useEffect, useRef } from "react";
import { LayoutContext } from "../../context";
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import Cookies from "js-cookie";
import { APIGetCoverageZones } from "../../api";


function CoverageBanner() {
    const { account, coverageOnboardingNeeded, setModalProfile } = useContext(LayoutContext);
    const isSurveyor = Array.isArray(account?.position) && account.position.includes('surveyor');
    if (!isSurveyor || !coverageOnboardingNeeded) return null;

    return (
        <Sheet
            onClick={() => setModalProfile(true)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                px: 2,
                py: 0.9,
                cursor: 'pointer',
                bgcolor: 'danger.500',
                color: '#fff',
                transition: 'opacity .2s',
                '&:hover': { opacity: 0.9 },
                flexShrink: 0,
            }}
        >
            <Typography level="body-xs" fontWeight={700} sx={{ color: 'inherit' }}>
                ⚠️ Укажите зоны покрытия, чтобы получать новые заявки — нажмите, чтобы заполнить
            </Typography>
        </Sheet>
    );
}

function KonsolBanner() {
    const { account, setModalKonsolConnect, effectiveRole } = useContext(LayoutContext);

    if (!effectiveRole?.includes('surveyor') && !effectiveRole?.includes('draftsman')) return null;
    if (account?.id_contractor_konsol) return null;

    const isPending = Boolean(account?.id_invite_konsol);

    return (
        <Sheet
            onClick={() => setModalKonsolConnect(true)}
            sx={{
                display: { xs: 'none', md: 'flex' },
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                px: 2,
                py: 0.9,
                cursor: 'pointer',
                bgcolor: isPending ? 'warning.300' : 'danger.500',
                color: isPending ? 'warning.800' : '#fff',
                transition: 'opacity .2s',
                '&:hover': { opacity: 0.9 },
                '&:active': { opacity: 0.8 },
                flexShrink: 0,
            }}
        >
            {isPending
                ? <HourglassEmptyRoundedIcon sx={{ fontSize: 16 }} />
                : <AccountBalanceWalletRoundedIcon sx={{ fontSize: 16 }} />
            }
            <Typography level="body-xs" fontWeight={600} sx={{ color: 'inherit' }}>
                {isPending
                    ? 'Документы на проверке — нажмите, чтобы подтвердить'
                    : 'Подключите Консоль.HRM для получения выплат'
                }
            </Typography>
        </Sheet>
    );
}


export default function LKPageSurveyor() {
    const {
        uploadProcesses, removeUploadProcess,
        // ── НОВОЕ ──
        account, tokenEmployee, setModalProfile,
        coverageOnboardingChecked, setCoverageOnboardingChecked,
        coverageOnboardingNeeded, setCoverageOnboardingNeeded,
    } = useContext(LayoutContext);
    const location = useLocation();

    useEffect(() => {
      console.log("Путь изменился на:", location.pathname);
    }, [location]);

    // ── НОВОЕ: одноразовая проверка зон покрытия после логина ──
    // useEffect(() => {
    //     if (coverageOnboardingChecked) return;            // уже проверяли в этой сессии
    //     if (!account?.id || !tokenEmployee) return;       // ждём аккаунт
    //     const isSurveyor = Array.isArray(account?.position) && account.position.includes('surveyor');
    //     if (!isSurveyor) {
    //         setCoverageOnboardingChecked(true);
    //         return;
    //     }

    //     let alive = true;
    //     APIGetCoverageZones(account.id, tokenEmployee).then(list => {
    //         if (!alive) return;
    //         setCoverageOnboardingChecked(true);
    //         if (!Array.isArray(list) || list.length === 0) {
    //             setCoverageOnboardingNeeded(true);
    //             setModalProfile(true);  // открываем профиль автоматически
    //         }
    //     });
    //     return () => { alive = false; };
    // }, [account?.id, tokenEmployee, coverageOnboardingChecked]);

    const scrollContainerRef = useRef(null);

    
    return (
        <Box sx={{ display: 'flex', height: '100dvh' }}>
            <SidebarSurveyor/>
            
            <Box
                ref={scrollContainerRef}
                sx={{
                    overflow: 'auto',
                    height: '100%',
                    width: '100%'
                }}
            >
                <HeaderLK/>

                {/* ── Баннер активных процессов выгрузки ── */}
                {/* {uploadProcesses?.length > 0 && uploadProcesses.map(proc => (
                    <Sheet
                        key={proc.process_id}
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            position: 'sticky',
                            top: 0,
                            zIndex: 98,
                            gap: 1,
                            px: 2,
                            py: 0.8,
                            bgcolor: proc.status === 'done'
                                ? 'success.100'
                                : proc.status === 'failed'
                                    ? 'danger.100'
                                    : 'primary.100',
                        }}
                    >
                        <Stack direction="row" alignItems="center" gap={1}>
                            {proc.status === 'done'
                                ? <CheckCircleRoundedIcon sx={{ fontSize: 16, color: 'success.600' }} />
                                : proc.status === 'failed'
                                    ? <ErrorRoundedIcon sx={{ fontSize: 16, color: 'danger.600' }} />
                                    : <SyncRoundedIcon sx={{ fontSize: 16, color: 'primary.600', animation: 'spin 1.5s linear infinite',
                                        '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(-360deg)' } }
                                    }} />
                            }
                            <Typography level="body-xs" fontWeight={600} sx={{
                                color: proc.status === 'done' ? 'success.700' : proc.status === 'failed' ? 'danger.700' : 'primary.700'
                            }}>
                                {proc.status === 'done'
                                    ? `Выгрузка завершена: ${proc.event_name}`
                                    : proc.status === 'failed'
                                        ? `Ошибка выгрузки: ${proc.event_name}`
                                        : `Выгрузка на Яндекс.Диск: ${proc.event_name}...`
                                }
                            </Typography>
                        </Stack>
                        {proc.status === 'failed' && (
                            <IconButton size="sm" onClick={() => removeUploadProcess(proc.process_id)}>
                                <CloseRoundedIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                        )}
                    </Sheet>
                ))} */}
                
                <CoverageBanner/>
                <KonsolBanner/>

                <Box
                    className="MainContent"
                    sx={{
                        // px: { xs: 2, md: 6 },
                        // mt: {
                        //     xs: 2,
                        //     md: 3,
                        // },
                        // pb: { xs: 2, sm: 2, md: 3 },
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                    }}
                >
                    <motion.main
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                    >
                        <Outlet context={{ scrollContainerRef }}/>
                    </motion.main>
                </Box>
            </Box>
        </Box>
    );
}